<template>
  <div>
    <NuxtPage />
  </div>
</template>

<script setup>
// Inter is loaded with font-display: swap, and assets/css/main.css carries a
// metric-compatible 'Inter Fallback' so the swap doesn't change line heights.
// Matching metrics is not the same as matching per-glyph advance widths though:
// a heading that sits just short of its wrap point in Arial can take an extra
// line once the real Inter arrives, and one extra line in a `text-4xl` heading
// moves everything under it (this was ~0.027 CLS on /brand-colors at 390px).
//
// The font is only discovered once the stylesheet has been parsed and the text
// laid out, so it starts late and lands after first paint. Preloading it makes
// it a first-round-trip request, which in practice means it arrives before the
// first paint and the swap never happens.
//
// Only the latin subset is preloaded: it covers the UI copy and the brand
// catalog, and the other six subsets are still fetched on demand by the
// @font-face rules if a page actually needs them. Importing with `?url` (rather
// than hardcoding a path) resolves to the same build-hashed asset the CSS
// points at, so this is a preload and not a second download.
import interLatin from '@fontsource-variable/inter/files/inter-latin-wght-normal.woff2?url'

useHead({
  link: [
    {
      rel: 'preload',
      as: 'font',
      type: 'font/woff2',
      href: interLatin,
      crossorigin: 'anonymous',
    },
  ],
})
</script>
